import { Container, Image } from 'react-bootstrap'
import { HowItWorksCardsContainer } from './style'
import { useTranslation } from 'react-i18next'
import { LRContainer } from 'style/styledItems'
import StyledButton from 'components/Elements/StyledButton'
import { useHistory } from 'react-router-dom'

function HowItWorksCards() {
  const history = useHistory()
  const { t } = useTranslation()
  const img1 = 'https://image.anecdobio.com/how_it_works1.jpg'
  const img2 = 'https://image.anecdobio.com/how_it_works2.jpg'
  const img3 = 'https://image.anecdobio.com/how_it_works3.jpg'

  const changeLocation = (e, placeToGo) => {
    // e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    history.push(placeToGo)
    window.location.reload()
  }

  return (
    <HowItWorksCardsContainer>
      <Container className="h-100">
        <h1>{t('how_cards_header')}</h1>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('how_card1_title')}</h2>
            <h4>{t('how_card1_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img1} />
          </div>
        </LRContainer>
        <LRContainer imgPos="R">
          <div className="lr-content lr-item">
            <h2>{t('how_card2_title')}</h2>
            <h4>{t('how_card2_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img2} />
          </div>
        </LRContainer>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('how_card3_title')}</h2>
            <h4>{t('how_card3_description')}</h4>
            <StyledButton
              className="btn-blue btn-get-started"
              title={t('getstarted')}
              width={'152px'}
              onClick={(e) => changeLocation(e, '/get-started')}
            />
          </div>
          <div className="lr-img lr-item">
            <Image src={img3} />
          </div>
        </LRContainer>
      </Container>
    </HowItWorksCardsContainer>
  )
}

export default HowItWorksCards
